var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object-renderer',{attrs:{"value":_vm.value,"entity-id":_vm.params.entityId,"view-mode":"form","allow-open":true}})}
var staticRenderFns = []

export { render, staticRenderFns }